import TeamTable from '../TeamTable';

const Distance145 = () => {
  return <TeamTable distance={"145"} targetType={"PRE"}/>;
};
export default Distance145;
